import DataTableV2ItemEdit from '@/agilis/components/DataTableV2/DataTableV2ItemEdit/DataTableV2ItemEdit.js'
import Configuration from '@/agilis/util/Configuration'

import AreaTree from '@/applications/sales/components/AreaTree/AreaTree.vue'

export default {
  name: 'PriceItemTableEdit',
  mixins: [DataTableV2ItemEdit],

  data () {
    return {
      formCustomComponents: {
        AreaTree
      }
    }
  },

  computed: {
    computedSubtitle () {
      if (this.mode === 'insert') {
        return this.$t('sales.label.priceItem')
      }
      return this.$t('sales.label.priceItem') + ' ' + this.trackerId
    },

    computedTitle () {
      const priceListId = this.itemDTO.priceListId || this.$parent.$parent.priceListId
      const trackerType = Configuration.getTrackerType(this.applicationId, this.trackerTypeId)

      const priceListConfig = trackerType?.priceList[priceListId]
      return priceListConfig && (this.$t('sales.label.priceList') + ': ' + this.$t(priceListConfig.name))
    }
  },

  methods: {
    beforeChange (delta) {
      if (delta.companyName) {
        delta.dimension3IdStr = null
      }
      return delta
    }
  }
}
